import { URL_BASE_API } from '../configs/urlConfigs';

import service from './api';

export const travelFieldsMasterList = (request) => {    
    const ENDPOINT = URL_BASE_API+'super-admin/travel-config-master/';  
    return service.get(ENDPOINT);
}

export const travelFieldCreate = (request) => {  
    const ENDPOINT = URL_BASE_API+'super-admin/travel-config-master/';
    return service.post(ENDPOINT,request.data); 
}

export const travelFieldModify = (request) => {  
    const ENDPOINT = URL_BASE_API+'super-admin/travel-config-master-update/'+request.data.field_id;
    return service.put(ENDPOINT,request.data); 
}

export const travelFieldDelete = (request) => {  
    const ENDPOINT = URL_BASE_API+'super-admin/travel-config-master-delete/'+request.data.field_id;
    return service.put(ENDPOINT,request.data); 
}

export const affiliateTravelSettings = (request) => {    
    const ENDPOINT = URL_BASE_API+'affiliate/travel-settings/';  
    return service.get(ENDPOINT);
}



